import React from 'react';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import PhoneOutlined from '@material-ui/icons/PhoneOutlined';
import NotificationsNone from '@material-ui/icons/NotificationsNone';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 0,
  },
  appBar: {
    background: '#F8F8F8',
    color: '#222',
    zIndex: theme.zIndex.drawer + 1,
  },
  iconButton: {
    width: 36,
    height: 36,
    color: '#fff',
    fontWeight: 100
  },
  flexMenuWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  }
});


class AppBarTransparent extends React.PureComponent {

  state = {
    anchorEl: null,
  };


  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleBackButton = (e) => {
    this.props.history.goBack()
  }

  render() {
    const { classes, background } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <AppBar position="fixed"  style={{ background: background, boxShadow: 'none'}}>
        <Toolbar>

          <IconButton className={classes.menuButton} onClick={this.handleBackButton} style={{color: '#fff'}}>
            <ArrowBack />
          </IconButton>

            <div style={{flexGrow: 1, display: 'flex', justifyContent: 'flex-end'}}>
              <IconButton
                aria-haspopup="true"
                className={classes.iconButton}
              >
                <NotificationsNone />
              </IconButton>
              <IconButton
                aria-haspopup="true"
                className={classes.iconButton}
              >
                <PhoneOutlined />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={this.handleClose}
              >
                <MenuItem onClick={this.handleClose}>Profile</MenuItem>
                <MenuItem onClick={this.handleClose}>My account</MenuItem>
              </Menu>
            </div>
          
        </Toolbar>
      </AppBar>
    )
  }
}

export default connect(state => ({
  auth: state.auth
}))(withStyles(styles)(AppBarTransparent));


// WEBPACK FOOTER //
// ./src/modules/shared/components/AppBarTransparent.js